
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ProgressBar extends Vue {
    @Prop() currentPage!: string

    progressStates = {
        create: ['is-active', 'is-pending', 'is-pending'],
        summary: ['is-complete', 'is-active', 'is-pending'],
        success: ['is-complete', 'is-complete', 'is-active']
    }

    get stateNames (): string[] {
        return [
            'progressBar.create',
            'progressBar.summary',
            'progressBar.success'
        ]
    }
}
